import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { ToggleOption } from 'src/app/components/option-toggle/option-toggle.component';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';
import { UnifiedPipelineService } from 'src/app/services/infra/unifiedPipeline/unified-pipeline.service';

@Component({
  selector: 'app-ai-activity-page',
  templateUrl: './ai-activity-page.component.html',
  styleUrls: ['./ai-activity-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiActivityPageComponent implements OnInit {
  public isLoading = signal<boolean>(false);
  public activitySubtitlePath = 'enterpriseAiDetectionPage.tabs.activitySubtitle';
  public activityTooltipLabelPath = 'enterpriseAiDetectionPage.tabs.activityTooltip';
  public selectedToggle = signal<ToggleOption>('option1');
  public option1Text = signal<string>('Audit Log');
  public option2Text = signal<string>('In-Line');
  public option1Icon = signal<string>('radar');
  public option2Icon = signal<string>('brain');

  constructor(
    private readonly _featureFlagsService: FeatureFlagsService,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _unifiedPipelineService: UnifiedPipelineService
  ) {}

  public ngOnInit(): void {
    if (this._unifiedPipelineService.isEnabled()) {
      // Use shared service for source toggle initialization
      const toggleOption = this._unifiedPipelineService.initializeSourceToggle();
      this.selectedToggle.set(toggleOption);
    } else {
      // Legacy behavior: If URL has inline=true and FF is ON, default to In-Line (option2)
      const url = new URL(window.location.href);
      const inlineParam = url.searchParams.get('inline');
      const inlineFeatureOn = this._featureFlagsService.isFeatureEnabled(FeatureFlagTypes.InlinePrevention);
      if (inlineParam === 'true' && inlineFeatureOn) {
        this.selectedToggle.set('option2');
      } else {
        this._removeInlineParam();
      }
    }
  }

  public onToggleChange(option: ToggleOption): void {
    this.selectedToggle.set(option);
    if (this._unifiedPipelineService.isEnabled()) {
      this._unifiedPipelineService.updateSourceInUrl(option);
    } else {
      // Legacy behavior
      if (option === 'option1') {
        this._router.navigate([], {
          relativeTo: this._route,
          queryParams: {},
          replaceUrl: true,
        });
      } else if (option === 'option2') {
        this._router.navigate([], {
          relativeTo: this._route,
          queryParams: { inline: 'true' },
          replaceUrl: true,
        });
      }
    }
  }

  private _removeInlineParam(): void {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { inline: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
